export default class CustomTabs {

  els = {
    tabBtn: '[data-js-tab-btn]',
    tabNav: '[data-js-tab-nav]',
    tabBody: '[data-js-tab-body]',
    tabBodyPoint: '[data-js-tab-point]'
  }

  constructor() {
    this.tabNav = document.querySelector(this.els.tabNav)
    this.tabBody = this.tabNav ? document.querySelector(`[id=${this.tabNav.dataset.jsTabNav}]`) : ''
    this.currentTab = ''
    this.bindEvents();
  }

  changeTab({target}) {
    if (target.closest(this.els.tabBtn) && target.closest(this.els.tabBtn).dataset.jsTabBtn !== this.currentTab) {
      const currentBtn = target.closest(this.els.tabBtn);
      const tabValue = currentBtn.dataset.jsTabBtn;

      this.tabBody.querySelectorAll(this.els.tabBodyPoint).forEach(point => {
        let tabGroups = point.dataset.jsTabPoint.split(',');
        let targetGroup = tabGroups.find(groupType=> {
          return groupType.trim() === tabValue
        })
        if (!targetGroup) {
          point.classList.add('tab-point_hide')
        } else {
          point.classList.remove('tab-point_hide')
        }
      })

      this.currentTab = tabValue
    }
  }

  bindEvents() {
    if (document.querySelector(this.els.tabNav)) {
      document.querySelector(this.els.tabNav).addEventListener('click', (e)=>this.changeTab(e))
    }
  }
}